<template>
  <section class="infraestructura">
    <p class="titleColorSystem">infraestructura</p>
    <div class="sci-inf-content">
      <table class="sci-inf-table">
        <thead class="sci-inf-thead">
          <div class="sci-inf-busqueda">
          </div>
          <v-flex md5 xs12>
                <v-select
                  :items="tipos_busqueda"
                  label="Buscar por ..."
                  item-text="name"
                  item-value="id"
                  v-model="tipo_busqueda"
                ></v-select>
              </v-flex>
              <v-flex md5 xs12 v-if="tipo_busqueda == 1">
              <v-select
                v-model="tipo_infraestructuras"
                :items="tipo_infraestructura"
                item-value="name"
                item-text="name"
                @click:clear="limpiarCampos(page)"
                label="Tipos de infraestructura..."
                @change="getTipoInfraestructura()"
                 >
                </v-select>
            </v-flex>
          <v-flex d-flex xs12 sm12 md5 v-if="tipo_busqueda == 2">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar nombre, descripción, palabra clave..."
              clearable
              flat
              @click:clear="limpiarCampos(page)"
              :hint="`Se Encontraron
                ${infCount ? infCount : 0}
                Resultados`"
              @keyup.enter.native="getInfraestructuras(page, search),getInfraestructurasExcel(page, search)"
            ></v-text-field>
          </v-flex>
          <span class="sci-inf-count">
            <vue-excel-xlsx
              v-if="infraestructuras.data.length > 0"
              class="sci-inf-excel"
              :data="infraestructurasExcelData"
              :columns="columns"
              :filename="'Infraestructura'"
              :sheetname="'infraestructura'"
            >
              Descargar resultados
            </vue-excel-xlsx>
          </span>
          <tr class="sci-inf-tr1">
            <td>Institución</td>
            <td>Nombre</td>
            <td>Tipo</td>
            <td></td>
			      <td>Contacto</td>
          </tr>
        </thead>
        <span v-if="!infCount">
          <h3 class="font-weight-thin mb-3">SIN INFORMACIÓN</h3>
          <h4 class="subheading">POR FAVOR REALICE UNA BÚSQUEDA</h4>
        </span>
        <tbody v-else id="tbody" class="sci-inf-tbody">
          <tr
            v-for="(infraestructura, index) in infraestructuras.data"
            :key="index"
          >
            <span class="sci-inf-tr2">
              <td class="sci-inf-tr2-td">
                {{ infraestructura.institucion_academica ? infraestructura.institucion_academica.nombre : ""}}
              </td>
              <td class="sci-inf-tr2-td">
                {{ infraestructura.nombre ? infraestructura.nombre : "" }}
              </td>
              <td class="sci-inf-tr2-td">
                {{ infraestructura.tipo ? infraestructura.tipo : "" }}
              </td>
              <td class="">
              <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" v-on="on" flat @click.stop="$set(dialogNote, infraestructura.id, true)">
                    Ver más
                    </v-btn>
                  </template>
                  <span>Ver más información</span>
                </v-tooltip>
                <v-dialog v-model="dialogNote[infraestructura.id]" scrollable lazy max-width="600" max-height="600" :key="infraestructura.id">
                  <v-card>
                    <v-card-title class="justify-content-center">
                      <span class="grey--text">{{infraestructura.institucion_academica? infraestructura.institucion_academica.nombre : ""}}</span>
                      <span class="text-primary headline text-center">{{infraestructura.nombre ? infraestructura.nombre : ""}}</span> 
                    </v-card-title>
                    <v-card-text>
                      <v-flex>
                      <p class="text-left">Tipo de pruebas o análisis: </p>
                      <div
                        class="text-xs-left"
                        v-for="(
                          prueba, index
                        ) in infraestructura.tipos_prueba_analisis"
                        :key="index"
                      >
                        <v-chip>{{ prueba }}</v-chip>
                      </div>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          readonly
                          label="Ubicación"
                          v-model="infraestructura.ubicacion"
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          label="Responsable"
                          readonly
                          v-model="infraestructura.nombre_responsable"
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-textarea
                          label="Descripción"
                          readonly
                          v-model="infraestructura.descripcion"
                        ></v-textarea>
                      </v-flex>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.stop="$set(dialogNote, infraestructura.id, false)">Cerrar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
              <td class="sci-inf-tr2-td">
				  <v-tooltip bottom>
				  		<SentMailToAcademicas slot="activator" v-bind:institucionAcademica="infraestructura.institucion_academica"></SentMailToAcademicas>
					  <span>Click para enviar correo</span>
				  </v-tooltip>
				  </td>
            </span>
          </tr>
        </tbody>
        <v-spacer></v-spacer>
        <div class="pagination justify-content-center">
          <pagination
            :limit="vPaginator.limit"
            :data="infraestructuras"
            @pagination-change-page="getInfraestructuras"
          ></pagination>
        </div>
      </table>
    </div>
     <LoadingComponent :loading="dialogLoading"></LoadingComponent>
  </section>
</template>

<script>
import axios from "axios";
import SentMailToAcademicas from './capacidades_cti/SentMailToAcademicas.vue';
import LoadingComponent from '../components/LoadingDialog.vue';
export default {
    components:{
    SentMailToAcademicas,
    LoadingComponent
	},
  props: ["urlApi"],
  data() {
    return {
    dialogNote: {},  
    dialogLoading: false,
		page: 1,
      	columns: [
        { label: "Institución", field: "institucion_nombre"},
		    { label: "Nombre del equipo", field: "nombre" },
        { label: "Tipo", field: "tipo" },
        { label: "Tipos de prueba o analisis", field: "tipos_prueba_analisis" },
        { label: "Ubicación", field: "ubicacion" },
        { label: "Responsable", field: "responsable" },
        { label: "Descripción", field: "descripcion" },
      ],
      search: null,
      search2: null,
      load: 1,
      tipo_infraestructuras: "",
      tipo_busqueda: {},
      tipos_busqueda: [
        { id: 1, name: "Tipo de infraestructura" },
        { id: 2, name: "Palabra clave" },
      ],
      tipo_infraestructura: [
        { id: 1, name: "Laboratorios de investigación"},
        { id: 2, name: "Plantas piloto"},
        { id: 3, name: "Laboratorios de pruebas"},
        { id: 4, name: "Laboratorios campos experimentales"}],
      infraestructuras: {
        current_page: 1,
        data: {
          infraestructuras: [],
        },
      },
      infraestructurasExcel: {
	  },
      vPaginator: {
        limit: 10,
      },
      selected: 4,
      CurrentElement: {},
    };
  },
  created() {
    // this.getInfraestructura();
    // this.getInfraestructuraExcel();
    // this.limpiarCampos();
  },
  watch: {
    // search: function (value) {
    //   this.getInfraestructuras();
    //   this.getInfraestructurasExcel();
    // },
  },
  computed: {
    infCount() {
      return this.infraestructuras.total;
    },
	infraestructurasExcelData() {
		let infraestructuras = []
    if (this.infraestructurasExcel.data){
		this.infraestructurasExcel.data.forEach(element => {
			let infraestructura = {
				institucion_nombre: element.institucion_academica ? element.institucion_academica.nombre: "",
				nombre: element.nombre ? element.nombre: "",
				tipo: element.tipo ? element.tipo: "",
        tipos_prueba_analisis: element.tipos_prueba_analisis ? element.tipos_prueba_analisis: "",
        ubicacion: element.ubicacion ? element.ubicacion: "",
        responsable: element.nombre_responsable ? element.nombre_responsable: "",
				descripcion: element.descripcion ? element.descripcion: ""
			}
			infraestructuras.push(infraestructura);
		});
		return infraestructuras;
	  }
  }
  },
  methods: {
    getInfraestructuras: function (page = 1) {
      this.dialogLoading = true
      var url = process.env.VUE_APP_API_URL + `/api/infraestructura?page=${page}&query=${this.search}`;
      axios
        .get(url)
        .then((response) => {
          this.infraestructuras = response.data;
        })
        .catch((error) => console.log("Error ", error))
        .finally(() => this.dialogLoading = false);
    },
    getInfraestructurasExcel: function (page = 1) {
      var url = process.env.VUE_APP_API_URL + `/api/infraestructura?perPage=200&page=1&query=${this.search}`;
      axios
        .get(url)
        .then((response) => {
          this.infraestructurasExcel = response.data;
        })
        .catch((error) => console.log("Error ", error))
    },

    getTipoInfraestructura(page = 1) {
      this.dialogLoading = true;
      var url = process.env.VUE_APP_API_URL + `/api/infraestructura?page=${page}&query=${this.tipo_infraestructuras}`;
      axios
        .get(url)
        .then((response) => {
          this.infraestructuras = response.data;
        })
        .catch((error) => console.log("Error ", error))
        .finally(() => (this.dialogLoading = false));
      var urlOutPage = process.env.VUE_APP_API_URL +  `/api/infraestructura?perPage=200&page=1&query=${this.tipo_infraestructuras}`;  
      axios
        .get(urlOutPage)
        .then((response) => {
          this.infraestructurasExcel = response.data;
        })
        .catch((error) => console.log("Error ", error))
        .finally(() => (this.dialogLoading = false));
    },
    
    limpiarCampos(page) {
      this.search = null;
      this.getInfraestructuras(page),
      this.getInfraestructurasExcel(page)
    },
  },
};
</script>

<style>
.sci-inf-title {
  margin: 3% auto 0%;
  text-transform: uppercase;
  color: rgba(255, 196, 0, 0.9);
  font-weight: bold;
  font-size: 1.5em;
}
.sci-inf-dot {
  font-weight: bold;
  color: rgba(0, 152, 255, 0.9);
}
.sci-inf-dot:before {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-right: 1.2%;
  border-radius: 1px 1px;
}
.sci-inf-dot:after {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 1.2%;
  border-radius: 0 0 0 0;
}
.sci-inf-texto {
  width: 50%;
  margin: 1% auto;
  line-height: 1.5;
}
.sci-inf-content {
  display: grid;
  grid-template-areas:
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show";
  grid-template-columns: 1fr;
  margin: 0 0 4% 0;
}
.sci-inf-table {
  display: grid;
  grid-area: sci-inf-table;
  border-spacing: 0;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  width: 95%;
  align-content: start;
  margin-bottom: 200px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-inf-thead {
  background: transparent;
  color: #fff;
  padding: 15px;
}
.sci-inf-busqueda {
  color: black;
  display: grid;
  justify-content: start;
  width: 100%;
  grid-template-columns: 1fr;
  position: relative;
}
.sci-inf-busqueda input {
  background: #fff;
  width: 40%;
  height: 25px;
  margin: 0 0 13px 0;
  border-radius: 0px 0 0 0px;
  border: none;
  padding: 0 15px;
  font-size: 0.8em;
  position: relative;
  background: gainsboro;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-inf-busqueda input:focus {
  outline: 0;
}
.sci-inf-busqueda input::placeholder {
  text-transform: uppercase;
}
.sci-inf-lupa {
  background: #0084ff;
  border: none;
  width: 35px;
  height: 32px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  position: absolute;
  top: 0;
  left: 37%;
}
.sci-inf-lupa:before {
  display: inline-block;
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: relative;
  left: -6px;
  top: -12px;
}
.sci-inf-lupa:after {
  content: "";
  width: 10px;
  height: 2px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  position: absolute;
  top: 18px;
  left: 17px;
}
.sci-aca-count {
  color: #0d47a1;
  font-size: 1.03rem;
  font-weight: bold;
  display: grid;
  text-align: left;
  padding: 1rem 1rem 1rem 0;
}
.sci-inf-excel {
  font-weight: bold;
  color: #0d47a1;
  font-size: 1.1rem;
  border: 1px solid #ccc;
  padding: 0.4rem;
  margin: 1rem 0 0rem 0;
  border-radius: 5px;
  display: grid;
  width: 100%;
}
.sci-inf-count {
  color: #0d47a1;
  font-size: 1.03rem;
  font-weight: bold;
  display: grid;
  text-align: left;
  padding: 1rem 1rem 1rem 0;
}
.sci-inf-tr1 {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 1fr;
  text-transform: uppercase;
  text-align: left;
  font-weight: 100;
  color: #000;
  background-color: gainsboro;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
}
.sci-inf-tbody {
  text-align: left;
}
.sci-inf-tr2 {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 1fr;
  padding: 10px;
  text-transform: uppercase;
}
.sci-inf-tr2-td {
  cursor: pointer;
  padding: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.active {
  background-color: rgba(0, 132, 255, 1);
  color: rgba(255, 196, 0, 1);
  font-weight: bold;
}
.sci-inf-anchor {
  text-overflow: ellipsis;
  display: flex;
  max-width: 210px;
}
.sci-inf-show {
  width: 96%;
  margin-top: 50px;
  display: grid;
  grid-area: sci-inf-show;
  background: rgba(245, 245, 245, 1) !important;
  border-radius: 0px 10px 0px 10px;
  -webkit-border-radius: 0px 10px 0px 10px;
  text-transform: uppercase;
}
.sci-inf-show2 {
  height: 340px;
}
.sci-inf-nameInf {
  text-align: center;
  width: 90%;
  max-height: 100px;
  margin: 2% auto 0;
  color: rgba(0, 132, 255, 1);
  font-size: 1.3em;
  padding: 5px 0 0 0;
}
.sci-inf-cont-info {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
}
.sci-inf-inf1-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.sci-inf-info1 {
  display: grid;
  width: 100%;
  margin: 0 auto;
}
.sci-inf-inf1-container {
  padding: 0;
}
.sci-inf-info1 div,
.sci-inf-info2 div {
  padding: 15px 0;
  color: #000;
}
.sci-inf-info1-p1,
.sci-inf-info1-p2,
.sci-inf-info1-p3,
.sci-inf-info1-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}
.sci-inf-info1-3 {
  padding: 0 0 5px 0;
}
.sci-inf-info2 {
  display: grid;
  color: #000;
}
.sci-inf-info2-p1,
.sci-inf-info2-p2,
.sci-inf-info2-p3,
.sci-inf-info2-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}
</style>
